import * as React from 'react';
import { useState } from 'react';
import { YStack } from 'tamagui';

import { Button, ButtonSize, ButtonVariant } from '../buttons/Button';
import { Sheet } from '../sheet/Sheet';
import { clampDateToBounds } from './dateBounds';
import { DatePicker } from './DatePicker';

interface DateSelectionSheetProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    defaultValue: Date;
    onConfirm: (date: Date) => void;
    minimumDate?: Date;
    maximumDate?: Date;
    confirmButtonText?: string;
    isInsideModal?: boolean;
}

export const DateSelectionSheet = ({
    title,
    isOpen,
    onClose,
    defaultValue,
    onConfirm,
    minimumDate,
    maximumDate,
    confirmButtonText = 'Save',
    isInsideModal,
}: DateSelectionSheetProps) => {
    const [selectedDate, setSelectedDate] = useState(() =>
        clampDateToBounds(defaultValue, minimumDate, maximumDate),
    );

    const handleConfirm = () => {
        onConfirm(clampDateToBounds(selectedDate, minimumDate, maximumDate));
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Sheet
            isOpen={isOpen}
            onClose={handleClose}
            forceKeyboardCompatibleBottomSheet
            isInsideModal={isInsideModal}
            title={title}
            showCloseButton
        >
            <YStack alignItems="center" width="100%">
                <DatePicker
                    value={selectedDate}
                    minimumDate={minimumDate}
                    maximumDate={maximumDate}
                    onChange={setSelectedDate}
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text={confirmButtonText}
                    onPress={handleConfirm}
                    buttonProps={{ marginTop: 18 }}
                />
            </YStack>
        </Sheet>
    );
};
